// import { IS_PRODUCTION } from '@/constants/config';

export const LOGO_BRAND_URL = 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/silicon-assistant-ui-brand-logo.svg?max_age=31536000';

export const AGENT_ID = {
  /**
   * 账户健康检查
   */
  ACCOUNT_HEALTH_CHECK: 107,
  /**
   * 数据汇总-详细分析
   */
  SUMMARY_ANALYSIS: 278, // IS_PRODUCTION ? 278 : 542,
  /**
   * 成长中心
   */
  GROWUP: 536,
};

// 指令类型常量
export const InstructionType = {
  CONTENT: 'content',
  AGENT: 'agent',
} as const;

// 指令类型联合类型
export type InstructionType = typeof InstructionType[keyof typeof InstructionType];

/**
 * 功能类型枚举常量
 */
export const FEATURE_TYPE = {
  /** 账户扫描 */
  ACCOUNT: 'ACCOUNT',
  /** AI 洞察报告 */
  REPORT: 'REPORT',
  /** 数据看板生成 */
  DASHBOARD: 'DASHBOARD',
  /** 数据快查 */
  DATA_QUERY: 'DATA_QUERY',
  /** 热门创意特征 */
  CREATIVE: 'CREATIVE',
  /** 成长中心报告 */
  GROWUP_REPORT: 'GROWUP_REPORT',
} as const;

/**
 * 功能类型值类型
 */
export type FeatureType = typeof FEATURE_TYPE[keyof typeof FEATURE_TYPE];

/**
 * 常用指令数据
 */
export const RECOMMENDED_COMMANDS = [
  {
    id: 1,
    text: '看下近7天我花费前100的创意素材以及数据表现，包含花费、点击率、转化率等主要指标',
    tag: 'HOT',
    tagColor: 'orange',
  },
  {
    id: 2,
    text: '最近7天分版位的消耗、曝光、点击、转化量和转化成本',
    tag: 'HOT',
    tagColor: 'orange',
  },
  {
    id: 3,
    text: '昨天花费较高的账户数据表现',
  },
  {
    id: 4,
    text: '扫描一下整体资金预算情况',
    tag: 'HOT',
    tagColor: 'orange',
  },
  {
    id: 5,
    text: '扫描一下所有账户的表现情况',
    tag: 'HOT',
    tagColor: 'orange',
  },
  {
    id: 6,
    text: '帮我找出近7天转化率最高且消耗>100的TOP 10广告',
  },
  {
    id: 7,
    text: '昨天消耗top10广告的消耗、曝光、点击、转化量和转化成本',
  },
  {
    id: 8,
    text: '低效广告扫描',
  },
  {
    id: 9,
    text: '近 7 天各个账户花费、展示、点击、目标转化等数据表格',
  },
  {
    id: 10,
    text: '全账户广告效果异常问题扫描',
    tag: 'HOT',
    tagColor: 'orange',
  },
  {
    id: 11,
    text: '分析下昨日分优化目标的核心指标对比数据',
  },
  {
    id: 12,
    text: '近3天行业热门标签元素推荐',
  },
  {
    id: 13,
    text: '今天至今的不同广告的花费、曝光、点击、转化量、CPA等核心指标',
  },
  {
    id: 14,
    text: '近7天分性别人群的转化量和转化成本',
  },
  {
    id: 15,
    text: '分析近7天行业内高花费素材的创意标签',
  },
  {
    id: 16,
    text: '分析一下近14天不同年龄人群的转化率',
  },
  {
    id: 17,
    text: '快速查询昨天花费最高的账户在今天的花费和效果情况。',
  },
  {
    id: 18,
    text: '扫描一下有哪些广告效果异常的账户',
  },
  {
    id: 19,
    text: '昨日分账户的花费、cpm、cpc',
  },
  {
    id: 20,
    text: '昨天不同版位的花费与广告效果数据',
  },
  {
    id: 21,
    text: '分析近3天行业内高点击率素材的创意标签',
  },
  {
    id: 22,
    text: '近7天我播放效果最好的创意',
  },
  {
    id: 23,
    text: '扫描一下我的账户存在哪些异常问题？',
  },
  {
    id: 24,
    text: '扫描一下账户整体的资金与预算情况怎么样？',
  },
  // {
  //   id: 25,
  //   text: '扫描近7天消耗TOP5客户的账户存在哪些异常问题',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 26,
  //   text: '扫描所属服务商类型为子账号的账户存在哪些异常问题',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 27,
  //   text: '扫描消耗TOP5广告主行业的账户存在哪些异常问题',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 28,
  //   text: '扫描消耗TOP3服务商ID的账户存在哪些异常问题',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 29,
  //   text: '近7天消耗top5服务商ID的消耗、曝光、点击、转化量和转化成本',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 30,
  //   text: '昨天消耗top5客户的账户消耗、曝光、点击、转化量和转化成本',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 31,
  //   text: '近14天消耗top5子账号ID的消耗、曝光、点击、转化量和转化成本',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
  // {
  //   id: 32,
  //   text: '今天分时消耗top5客户的账户消耗、曝光、点击、转化量和转化成本',
  //   tag: 'HOT',
  //   tagColor: 'orange',
  // },
];


/**
* 功能
*/
export const SKILL_LIST = [
  {
    id: FEATURE_TYPE.ACCOUNT,
    title: '账户扫描',
    description: 'AI 账户全维度的异常识别总结',
    iconUrl: '//qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1765520680008.png?max_age=31536000',
  },
  // {
  //   id: FEATURE_TYPE.REPORT,
  //   title: 'AI 洞察报告',
  //   description: 'AI 洞察报告一键生成',
  //   iconUrl: '//qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1765520702413.png?max_age=31536000',
  // },
  // {
  //   id: FEATURE_TYPE.DASHBOARD,
  //   title: '数据看板生成',
  //   description: 'AI 一键生成数据看板',
  //   iconUrl: '//qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1765520715639.png?max_age=31536000',
  // },
  {
    id: FEATURE_TYPE.CREATIVE,
    title: '热门创意特征',
    description: '全局查询行业爆款创意特征脚本',
    iconUrl: '//qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1765520728254.png?max_age=31536000',
  },
  {
    id: FEATURE_TYPE.DATA_QUERY,
    title: '数据快查',
    description: '一句话快速查询意向数据',
    iconUrl: '//qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1765520739487.png?max_age=31536000',
  },
];


/**
 * 从推荐命令中随机选择10条
 */
export const getRandomRecommendedCommands = () => {
  const shuffled = [...RECOMMENDED_COMMANDS].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, 10);
};

export const AI_ASSISTANT_REPORT_EVENT_NAME = {
  // 入口
  ENTRY: 'ai-assistant-entry',
  // 使用指南
  GUIDE_LINK: 'ai-assistant-home-guide-link',
  // 营销雷达卡片（前缀）
  ATTENTION_CARD_DISPLAY: 'ai-assistant-home-attention-card-display',
  ATTENTION_CARD_DETAIL_LINK: 'ai-assistant-home-attention-card-detail-link',
  // 数据汇总-详细分析
  SUMMARY_ANALYSIS: 'ai-assistant-home-summary-analysis',
  // 快捷指令（前缀）
  INSTRUCTION_COMMAND: 'ai-assistant-home-instruction-command',
  INSTRUCTION_FEATURE: 'ai-assistant-home-instruction-feature',

  // 成长中心AI助手入口(前缀)
  GROWUP_ENTRY: 'ai-assistant-growup-entry',
  GROWUP_NOTICE_REPORT: 'ai-assistant-growup-notice-report',
  GROWUP_NOTICE_CUSTOMIZE: 'ai-assistant-growup-notice-customize',
};
